<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Per-transfer details -->
  <ng-container *ngFor="let transfer of item.transfers; let i = index">
    <hr class="w-100 p-0 mb-3" style="border: none; border-top: 2px solid #000000;" />

    <div class="d-flex flex-column detail-item">
      <!-- Per-transfer status (only when multiple transfers) -->
      <div *ngIf="item.transfers.length > 1" class="d-flex justify-content-end align-items-start w-100 mb-3">
        <div class="d-flex flex-column justify-content-between mr-3" style="margin-top: 10px;">
          <span [class]="'status status-sidebar ' + getTranportStatusClass(transfer.status_id || transfer.statusId)">
            {{ transfer.status || transfer.statusName }}
          </span>
        </div>

        <ng-container *ngIf="transfer.status_id === 1 || transfer.status_id === 2">
          <button
            class="d-flex align-items-center justify-content-center py-1 px-1"
            style="border-bottom-left-radius: 10px; border: none; background-color: #facad3; width: 35px; height: 35px;"
            (click)="onRemoveItem(item)"
          >
            <!-- Cancel icon for "Reservado" transfers (statusId 2) -->
            <div
              *ngIf="transfer.status_id === 2"
              class="item-button"
              title="cancel"
            >
              <img
                src="../../../../../../assets/icons/itinerary-detail/04-01.svg"
                alt="cancel"
                style="
                  width: 20px;
                  filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                "
              />
            </div>

            <!-- Default trash icon for transfers in "Cotización" (statusId 1) -->
            <div
              *ngIf="transfer.status_id === 1"
              class="item-button"
              title="delete"
            >
              <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                style="fill: #ff3f63; width: 20px;" xml:space="preserve">
                <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                  c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                  c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                  c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                  c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C153.6,439.4,161.3,447,170.7,447z"/>
                <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                  "/>
                <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C324.3,439.4,331.9,447,341.3,447z"/>
              </svg>
            </div>
          </button>
        </ng-container>
      </div>

      <div class="d-flex flex-column mb-3">
        <p
          style="
            font-family: 'Rubik';
            font-size: 15px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: none;
          "
          class="m-0"
        >
          {{transfer.title}} {{transfer.paxAdults}} {{transfer.paxAdults === 1 ? 'pasajero' : 'pasajeros'}} ({{transfer.firstWay === 1 ? 'Ida' : 'Regreso'}})
        </p>
      </div>

      <div class="mb-3">
        <span *ngIf="transfer.rateClassId === 'R' || transfer.rateClass === 'R' || transfer?.pricing?.rateClass === 'R'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #34c26d; background-color: #defef4; text-transform: none; border-radius: 6px;">Reembolsable</span>
        <span *ngIf="transfer.rateClassId === 'NR' || transfer.rateClass === 'NR' || transfer?.pricing?.rateClass === 'NR'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #ed3b5b; background-color: #fde6ea; text-transform: none; border-radius: 6px;">No Reembolsable</span>
      </div>

      <div>
        <div
          class="py-2 px-3"
          style="
            display: inline-block;
            border-radius: 26.5px;
            background-color: #d5f9ed;
            font-size: 12.12px;
            font-family: 'Rubik';
            font-weight: 500;
            line-height: 1;
            text-transform: none;
            color: #5bca90;
          "
        >
          {{ transfer?.transferType }}
        </div>
      </div>

      <!-- Common transport info -->
      <div class="d-flex flex-column pt-3">
        <!-- Amount Transport (common) -->
        <div class="d-flex align-items-center mb-3" style="gap: 10px;">
          <div class="d-flex align-items-center" style="gap: 2px;">
            <img width="18" height="18" src="../../../../../../assets/icons/itinerary/persona.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ transfer?.paxAdults || 0 }}
            </span>
          </div>

          <div class="d-flex align-items-center" style="gap: 2px;">
            <img width="18" height="18" src="../../../../../../assets/icons/search-result/maleta.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ transfer?.vehicle?.bag?.maxWeightBag || 0 }}
            </span>
          </div>

          <div class="d-flex align-items-center" style="gap: 2px;">
            <img width="18" height="18" src="../../../../../../assets/icons/cart/MALETA 1.svg"/>
            <span
              style="
                font-size: 13px;
                font-weight: 600;
                font-family: 'Rubik';
                text-transform: none;
              "
            >
              {{ transfer?.vehicle?.bag?.maxBag || 0 }}
            </span>
          </div>
        </div>
      </div>

      <!-- Date -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Inicio:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 600;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ transfer?.formTransport?.firstArrivalDate | date: "EEE. dd MMM yyyy" }}
        </span>

        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ transfer?.formTransport?.firstTime }} hs
        </span>
      </div>

      <!-- Pick Up -->
      <div class="d-flex flex-column mb-3">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #2c2c2c;
            text-transform: none;
          "
        >
          Pick Up:
        </span>
        <p
          style="
            font-family: 'Rubik';
            font-size: 12px;
            color: #747474;
            font-weight: 400;
            line-height: 1.2;
            margin: 0;
          "
        >
          {{ transfer?.formTransport?.firstOrigin?.name}}
        </p>
      </div>

      <!-- Drop OFF -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #2c2c2c;
            text-transform: none;
          "
        >
          Drop Off:
        </span>
        <p
          style="
            font-family: 'Rubik';
            font-size: 12px;
            color: #747474;
            font-weight: 400;
            line-height: 1.2;
            margin: 0;
          "
        >
          {{ transfer?.formTransport?.firstDestination?.name}}
        </p>
      </div>
    </div>

    <div
      class="mr-3 mb-4"
    >
      <p
        class="m-0"
        style="
          font-family: 'Muli', sans-serif;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.2;
          text-transform: none;
        "
      >
        Tarifa Traslado {{ transfer.firstWay === 1 ? 'Ida' : 'Regreso' }}:
      </p>
      <div class="d-flex justify-content-start align-items-center" style="gap: 1px;">
        <p
          class="m-0"
          style="
            font-family: 'Rubik', sans-serif;
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2
          ">
          {{ currencyAgency?.code }}
          <span *ngIf="(transfer?.statusId || transfer?.status_id) !== 5">{{ getTransferDisplayPrice(transfer) | number: "1.2-2" }}</span>
          <span *ngIf="(transfer?.statusId || transfer?.status_id) === 5">{{ 0 | number: "1.2-2" }}</span>
          </p>
          <usb-tooltip-convert-amount
            *ngIf="(transfer?.statusId || transfer?.status_id) !== 5"
            [clientsSettingAppBooking]="clientsSettingAppBooking"
            [currencyProduct]="currencyAgency?.code"
            [valueProduct]="getTransferDisplayPrice(transfer)">
          </usb-tooltip-convert-amount>
        </div>

        <div
          *ngIf="transfer?.currency !== currencyAgency?.code && (transfer?.statusId || transfer?.status_id) !== 5"
        class="d-flex justify-content-start flex-column"
      >
        <p
          class="mb-0"
          style="font-family: 'Rubik', sans-serif; font-size: 13px; font-weight: 500; line-height: 1.2;"
        >
          {{ transfer?.currency }} {{ transfer?.netPriceAgent | number: "1.2-2" }}
        </p>

        <span style="font-family: 'Muli', sans-serif; font-size: 10px; font-weight: 400; line-height: 1.2; text-transform: none;">
          impuestos incluidos
        </span>
      </div>
    </div>
  </ng-container>
</usb-base-item>
